"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactHookForm = require("react-hook-form");

var _default = function _default(formSetup) {
  var context = (0, _reactHookForm.useFormContext)();
  var locals = (0, _reactHookForm.useForm)(formSetup);
  return context || locals;
};

exports["default"] = _default;